<template>

    <b-form class="super-admin-form">
      <b-form-row class="input-row">
        <b-col md="6">
          <label>Όνομα</label>
          <b-form-input
              v-model="adminDetails.name"
              required
              :state="validation.validationFormItems.name"
          ></b-form-input>
          <b-form-invalid-feedback :state="validation.validationFormItems.name">
            Το όνομα πρέπει να περιέχει μόνο γράμματα.
          </b-form-invalid-feedback>
        </b-col>
        <b-col md="6">
          <label>Επώνυμο</label>
          <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
            <b-form-input
                v-model="adminDetails.surname"
                required
                :state="validation.validationFormItems.surname"
            ></b-form-input>
            <b-form-invalid-feedback :state="validation.validationFormItems.surname">
              Το επώνυμο πρέπει να περιέχει μόνο γράμματα.
            </b-form-invalid-feedback>
          </b-input-group>
        </b-col>
      </b-form-row>

      <b-form-row class="input-row">
        <b-col md="6">
          <label>Email</label>
          <b-form-input
              v-model="adminDetails.email"
              :state="validation.validationFormItems.email"
          ></b-form-input>
          <b-form-invalid-feedback :state="validation.validationFormItems.email">
            Δεν αποτελεί έγκυρη διεύθυνση e-mail.
          </b-form-invalid-feedback>
        </b-col>
        <b-col md="6">
          <label>Α.Φ.Μ.</label>
          <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
            <b-form-input
                v-model="adminDetails.afm"
                required
                :state="validation.validationFormItems.afm"
            ></b-form-input>
            <b-form-invalid-feedback :state="validation.validationFormItems.afm">
              Το ΑΦΜ που καταχωρήσατε δεν είναι έγκυρο.
            </b-form-invalid-feedback>
          </b-input-group>
        </b-col>
      </b-form-row>

      <b-form-row class="input-row">
        <b-col md="6">
          <label>Α.Μ.</label>
          <b-form-input
              v-model="adminDetails.am"
              required
              :state="isValidDigitsAm"
          ></b-form-input>
          <b-form-invalid-feedback :state="isValidDigitsAm">
              Ο αριθμός μητρώου πρέπει να έχει 11 ψηφία και μόνο αριθμούς.
          </b-form-invalid-feedback>
        </b-col>
        <b-col md="6">
          <label>Α.Μ.Κ.Α.</label>
          <b-form-input
              v-model="adminDetails.amka"
              required
              :state="validation.validationFormItems.amka"
          ></b-form-input>
          <b-form-invalid-feedback :state="validation.validationFormItems.amka">
            Το ΑΜΚΑ πρέπει να περιέχει μόνο αριθμούς.
          </b-form-invalid-feedback>
        </b-col>
      </b-form-row>

      <b-form-row class="input-row">
        <b-col md="6">
          <label>Τηλέφωνο</label>
          <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
            <b-form-input
                v-model="adminDetails.workTelephone"
                :state="validation.validationFormItems.workTelephone"
            ></b-form-input>
            <b-form-invalid-feedback :state="validation.validationFormItems.workTelephone">
              Το τηλέφωνο πρέπει να περιέχει μόνο αριθμούς.
            </b-form-invalid-feedback>
          </b-input-group>
        </b-col>
      </b-form-row>

      <b-alert :show="alert.showAlert" dismissible :variant="alert.currentAlert.type">
        {{ alert.currentAlert.text }}
      </b-alert>

      <div class="form-buttons">
        <b-button variant="outline-primary" @click.prevent="resetInputFields(); resetAlerts(); resetTips();">Επαναφορά</b-button>
        <b-button variant="primary" @click.prevent="createAdmin">Αποθήκευση</b-button>
      </div>

    </b-form>
</template>

<script>
import {HTTP} from "@/main";
import {Structs} from "@/structs";

export default {
  name: "CreateSuperAdminForm",
  data() {
    return {
      adminDetails: {
        name: "",
        surname: "",
        email: "",
        afm: "",
        am: "",
        amka: "",
        workTelephone: ""
      },
      alert: {
        success: {
          text: "Ο νέος διαχειριστής προστέθηκε με επιτυχία.",
          type: "success"
        },
        error: {
          text: "Ο Χρήστης είναι ήδη καταχωρημένος ως διαχειριστής",
          type: "danger"
        },
        currentAlert: {},
        inputError: false,
        showAlert: false
      },
      validation: {
        invalidForm: false,
        validationFormItems: {
            name: null,
            surname: null,
            workTelephone: null,
            am: {
                validNumbers: false
            },
            amka: null,
            afm: null,
            email: null
        }
      }
    }
  },
  methods: {
    createAdmin: function () {
      const url = "/admin/soldier-admin"

      let admin = Structs.Admin();

      admin.strkProsKwd = this.adminDetails.am
      admin.afm = this.adminDetails.afm
      admin.email = this.adminDetails.email
      admin.workTelephone = this.adminDetails.workTelephone
      admin.onoma = this.adminDetails.name
      admin.epwnymo = this.adminDetails.surname
      admin.amka = this.adminDetails.amka

      if(this.formValidation()) {
        this.validation.invalidForm = false;
        this.$store.dispatch("loading")
        HTTP.post(url, admin)
          .then(response => {
            this.inputError = false
            this.alert.showAlert = true
            this.alert.currentAlert = this.alertChoice()

            this.resetInputFields()
            this.resetTips()
          }).catch((e) => {

            this.inputError = true
            this.alert.showAlert = true

            this.alert.currentAlert = this.alertChoice()
            this.resetInputFields()
            this.resetTips()
          }).finally(() => this.$store.dispatch("stop_loading"))
      }
      else {
        this.validation.invalidForm = true;
      }
    },
    resetInputFields: function (){
      this.adminDetails = {
        name: "",
        surname: "",
        email: "",
        afm: "",
        am: "",
        amka: "",
        workTelephone: ""
      }
    },
    resetAlerts: function () {
      this.alert.showAlert = false
    },
    resetTips() {
      this.validation.validationFormItems = {
        am: {
          validNumbers: false
        }
      }
    },
    alertChoice: function () {
      if(this.inputError)
        return this.alert.error

      return this.alert.success
    },
    formValidation: function () {

      const validator = this.$validator;

      const isValidName = validator.onlyLetters(this.adminDetails.name);
      const isValidSurname = validator.onlyLetters(this.adminDetails.surname);
      const isValidPhone = validator.onlyNumbers(this.adminDetails.workTelephone);

      //-----AM VALIDATIONS-----//
      const isValidAm = validator.onlyNumbers(this.adminDetails.am);

      //-----AMKA VALIDATIONS-----//
      const isValidAmka = validator.onlyNumbers(this.adminDetails.amka);

      //-----AFM VALIDATIONS-----//
      const hasValidDigitsAfm = validator.afmDigitsValidation(this.adminDetails.afm)
      const isAlgoValidAfm = validator.afmValidation(this.adminDetails.afm)
      const hasOnlyNumbersAfm = validator.onlyNumbers(this.adminDetails.afm);
      let isValidAfm = hasValidDigitsAfm && isAlgoValidAfm && hasOnlyNumbersAfm

      //-----EMAIL VALIDATIONS-----//
      const isValidEmail = validator.validateEmail(this.adminDetails.email);

      this.validation.validationFormItems = {
        name: isValidName,
        surname: isValidSurname,
        workTelephone: isValidPhone,
        am: {
            validNumbers: isValidAm
        },
        amka: isValidAmka,
        afm: isValidAfm,
        email: isValidEmail
      }

      return isValidEmail && isValidPhone && isValidSurname && isValidName && isValidAm && isValidAmka && isValidAfm
    }
  },
  computed: {
    isValidDigitsAm: function () {
        return this.$validator.amValidation(this.adminDetails.am)
    }
  },
}
</script>

<style scoped>
  .super-admin-form {
    padding: 25px;
    background-color: #f5f5f5;
    margin-top: 20px;
  }

  .input-row {
    margin-bottom: 20px;
  }

  .form-buttons {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    justify-content: space-between;
    width: 60%;
  }
</style>
